import { z } from 'zod';
export const baseEndocrineSchema = z.object({
    bgReading: z.string().optional(),
    bgTiming: z.string().optional(),
    glucoseTrend: z.string().optional(),
    hypoglycemiaEpisode: z.string().optional(),
    hyperglycemiaEpisode: z.string().optional(),
    ssHyperglycemia: z.array(z.string()).optional(),
    ssHypoglycemia: z.array(z.string()).optional(),
    diabeticMgmt: z.array(z.string()).optional(),
    insulinAdminBy: z.array(z.string()).optional(),
    leftSkinIntegrity: z.string().optional(),
    leftSensation: z.string().optional(),
    leftNails: z.string().optional(),
    rightSkinIntegrity: z.string().optional(),
    rightSensation: z.string().optional(),
    rightNails: z.string().optional(),
    narrative: z.string().optional(),
    changeFromLastVisit: z.string().optional(),
});
